import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { logoutRequest } from 'app/auth.api';
import { setManagerAccessToken } from 'app/tokens';
import { useUser } from 'hooks/useUser';
import { DropdownMenu } from 'radix-ui';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router';
import { setIsLoggedOut } from 'rtk/ConfigSlice';
import { useAppDispatch } from 'rtk/query/hooks';
import './styles.css';

const NavbarDropdown = () => {
  const { t } = useTranslation('NavBar');
  const dispatch = useAppDispatch();
  const user = useUser();
  const navigate = useNavigate();

  const logout = () => {
    logoutRequest()
      .then((result) => {
        setManagerAccessToken('');
        dispatch(setIsLoggedOut());
        navigate('/login');
        console.log('logout result', result);
      })
      .catch((error) => {
        console.log('logout error', error);
      });
  };

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <button className="IconButton cursor-pointer" aria-label={t('userMenu.customiseOptions')}>
          <Avatar>
            <AvatarFallback>
              {user && user.first_name[0]}
              {user && user.last_name[0]}
            </AvatarFallback>
          </Avatar>
        </button>
      </DropdownMenu.Trigger>

      <DropdownMenu.Portal>
        <DropdownMenu.Content className="DropdownMenuContent" sideOffset={5} style={{ zIndex: 2 }}>
          <DropdownMenu.Item
            className="DropdownMenuItem cursor-pointer"
            // onClick={logout}
          >
            <Link to={`/settings`}>
              {user && user.first_name} {user && user.last_name}
            </Link>
          </DropdownMenu.Item>

          {/*
          <DropdownMenu.Sub>
            <DropdownMenu.SubTrigger className="DropdownMenuSubTrigger">
              Toggle theme mode
            </DropdownMenu.SubTrigger>
            <DropdownMenu.Portal>
              <DropdownMenu.SubContent
                className="DropdownMenuSubContent"
                sideOffset={2}
                alignOffset={-5}
              >
                <DropdownMenu.Item className="DropdownMenuItem">
                  <ThemeModeToggle.ActionDark />
                </DropdownMenu.Item>

                <DropdownMenu.Item className="DropdownMenuItem">
                  <ThemeModeToggle.ActionLight />
                </DropdownMenu.Item>

                <DropdownMenu.Item className="DropdownMenuItem">
                  <ThemeModeToggle.ActionSystem />
                </DropdownMenu.Item>

              </DropdownMenu.SubContent>
            </DropdownMenu.Portal>
          </DropdownMenu.Sub>
          */}

          <DropdownMenu.Item className="DropdownMenuItem cursor-pointer" onClick={logout}>
            {t('userMenu.logout')}
          </DropdownMenu.Item>

          <DropdownMenu.Arrow className="DropdownMenuArrow" />
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
};

export default NavbarDropdown;
